import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import styled, { css } from 'styled-components';
import axios from 'axios';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import fetchConfig from '../../Constants/fetch';

const AccordionFAQ = prop => {
    const [expanded, setExpanded] = useState(false);
    const { t } = useTranslation();
    const handleChange = panel => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    return (
        <>
            {prop.faq.map((element, index) => {
                const panelId = `panel${index}`;
                return (
                    <>
                        <Accordion
                            style={{ marginTop: '10px' }}
                            key={panelId}
                            expanded={expanded === panelId}
                            onChange={handleChange(panelId)}
                        >
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls={`panel${index}-content`}
                                id={`panel${index}-header`}
                                index={`accordion_${index}`}
                            >
                                {t(`login.help.help_faqs.faqs.${element.id}.faq_title`, {
                                    id: element.id,
                                })}
                            </AccordionSummary>
                            <AccordionDetails>
                                {t(`login.help.help_faqs.faqs.${element.id}.info_text`, {
                                    id: element.id,
                                })}
                            </AccordionDetails>
                        </Accordion>
                    </>
                );
            })}
        </>
    );
};

export default AccordionFAQ;
